import { render, staticRenderFns } from "./DecisionDiamondElement.vue?vue&type=template&id=47ac52a8&scoped=true"
import script from "./DecisionDiamondElement.vue?vue&type=script&lang=js"
export * from "./DecisionDiamondElement.vue?vue&type=script&lang=js"
import style0 from "./DecisionDiamondElement.vue?vue&type=style&index=0&id=47ac52a8&prod&scoped=true&lang=scss"
import style1 from "./DecisionDiamondElement.vue?vue&type=style&index=1&id=47ac52a8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47ac52a8",
  null
  
)

export default component.exports